import UserService from '~/services/UserService';
import * as SLUtils from '~/utils/SharedLibrary';

export const state = () => ({});

export const getters = {
  enableSharedLibrary: (_state, _getters, rootState, rootGetters) => {
    const user = new UserService(rootState.root.user);
    const validByOrgWhitelisting = SLUtils.isUserInWhitelistedPaidOrganization(user);

    const serverData = rootGetters['root/serverData'];
    const validByCountry = SLUtils.isUserInWhitelistedCountry(user?.country || serverData?.requestCountry);

    return (validByCountry && user.organizationIds?.[0]) || validByOrgWhitelisting;
  },

  hasSharedLibraryPriviledges: (_state, _getters, rootState) => {
    const user = new UserService(rootState.root.user);
    return !!user?.priviledges?.sharedLibrary;
  },
  pilotOrgs() {
    return SLUtils.pilotOrgs || [];
  },
};

export const mutations = () => ({});

export const actions = () => ({});

const sharedLibrary = {
  state,
  getters,
  mutations,
  actions,
};

export default sharedLibrary;
